import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { Tooltip } from 'flowbite-react';
import React from 'react';

import { CheckState } from './checkState';

interface TriStateCheckboxProps {
  state: CheckState;
  onChange: (newState: CheckState) => void;
  label: string;
  className?: string;
  tooltips?: {
    checked?: string;
    excluded?: string;
    unchecked?: string;
  };
  tooltipPlacement?: 'top' | 'right' | 'bottom' | 'left';
}

const defaultTooltips = {
  checked: 'Inclus',
  excluded: 'Exclus',
  unchecked: 'Non considéré',
};

const TriStateCheckbox: React.FC<TriStateCheckboxProps> = ({
  state,
  onChange,
  label,
  className = '',
  tooltips = {},
  tooltipPlacement = 'right',
}) => {
  const handleClick = () => {
    const nextState = {
      [CheckState.UNCHECKED]: CheckState.CHECKED,
      [CheckState.CHECKED]: CheckState.EXCLUDED,
      [CheckState.EXCLUDED]: CheckState.UNCHECKED,
    }[state];
    onChange(nextState);
  };

  const getTooltipContent = () => {
    const mergedTooltips = { ...defaultTooltips, ...tooltips };
    switch (state) {
    case CheckState.CHECKED:
      return mergedTooltips.checked;
    case CheckState.EXCLUDED:
      return mergedTooltips.excluded;
    default:
      return mergedTooltips.unchecked;
    }
  };

  return (
    <div className={`flex items-center ${className}`}>
      <Tooltip
        placement={tooltipPlacement}
        content={getTooltipContent()}
      >
        <button
          onClick={handleClick}
          className={`mr-2 flex h-5 w-5 items-center justify-center rounded border
            ${state === CheckState.UNCHECKED ? 'bg-white' : ''}
            ${state === CheckState.CHECKED ? 'border-rgpd-green bg-rgpd-green' : ''}
            ${state === CheckState.EXCLUDED ? 'border-red-500 bg-red-500' : ''}
          `}
        >
          {state === CheckState.CHECKED && <CheckIcon className="h-4 w-4 text-white" />}
          {state === CheckState.EXCLUDED && <XMarkIcon className="h-4 w-4 text-white" />}
        </button>
      </Tooltip>
      <span>{label}</span>
    </div>
  );
};

export default TriStateCheckbox;

export { CheckState } from './checkState';
